import {useEffect, useState} from 'react';
import {Navigate} from 'react-router-dom';
import styled from 'styled-components';
import {Onboarding} from '@/components/Onboarding';
import {HamburgerMenuIcon} from '@/components/Icons';
import {MobileNavBar} from '@/components/NavBar/MobileNavBar';
import {useSession} from '@/hooks';
import {Map as MapComponent} from '@/map/components';
import {Map as MobileMapComponent} from '@/map/components/MobileMaps';
import {MapSidebar} from '@/map/components/Sidebar';
import {paths} from '@/router';
import {FullContainer} from '@/styled-components';
import {LAYOUT_Z_INDEX} from '@/styles';
import {useQueryClient} from '@tanstack/react-query';
import {isMobile} from 'react-device-detect';
import {MobileMapAgent} from '@/map/enums';

const Map = () => {
  const [openOnboarding, setOpenOnboarding] = useState<boolean>(false);
  const [showMobileNav, setShowMobileNav] = useState(false);
  const {user, isPaidUser} = useSession();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (user && !user.profile) {
      setOpenOnboarding(true);
    }
  }, [user]);

  useEffect(() => {
    return () => {
      queryClient.removeQueries({queryKey: ['map']});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isPaidUser) {
    return <Navigate to={{pathname: paths.home}} />;
  }

  if (isMobile) {
    return (
      <FullContainer>
        {showMobileNav ? (
          <MobileNavOverlay>
            <MobileNavBar defaultOpen onClose={() => setShowMobileNav(false)} />
          </MobileNavOverlay>
        ) : (
          <FloatingHamburger onClick={() => setShowMobileNav(true)}>
            <img src={HamburgerMenuIcon} alt="메뉴 열기" />
          </FloatingHamburger>
        )}
        <MobileMapComponent agent={MobileMapAgent.myfc} />
      </FullContainer>
    );
  }

  return (
    <FullContainer>
      <MapSidebar />
      <MapComponent />
      {openOnboarding && (
        <Onboarding onComplete={() => setOpenOnboarding(false)} />
      )}
    </FullContainer>
  );
};

const MobileNavOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR + 10};
`;

const FloatingHamburger = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
`;

export default Map;
